module.exports = __webpack_public_path__ + "img/7.019f005b.jpg";